<i18n>
{
  "fr": {
    "configuratorHeaderBackButton": {
      "title": "Quitter"
    }
  }
}
</i18n>

<template>
  <button type="button" class="configurator-header-back-button">
    {{ $t('configuratorHeaderBackButton.title') }}
  </button>
</template>

<script>
export default {
  name: 'ConfiguratorHeaderBackButton',
  props: {
    href: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style scoped lang="scss">
.configurator-header-back-button {
  font-weight: bold;
  color: $color-arapawa;
  background-color: $color-gray-wild-sand;
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0.75rem 0.75rem 0.75rem 0.625rem;
  border: solid 1px $color-arapawa;
  border-radius: 1.75rem;
  text-transform: uppercase;
  cursor: pointer;

  &::before {
    @extend %icon;
    @extend %icon--arrow-left1;

    margin-right: 0.3125rem;
    color: $color-arapawa;
    transition: transform $default-transition-duration;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>
